import { Typography, Box, Stack } from '@mui/material';
import LanguageSwitcher from '../../components/Shared/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import ThemeSwitcher from '../../components/Shared/ThemeSwitcher';
import { CustomerDetailsForm } from '../../components/Customer/CustomerDetailsForm_i18n-dj';

const GeneralSettings = () => {
    const { t } = useTranslation();

    return (
        <Box p={2}>
            <Typography variant="h4">{t('generalSettings.title')}</Typography>
            
            <Stack direction="row" spacing={2} sx={{ marginBottom: 0, marginTop: 0 }}>
                <div style={{ marginBottom: 20, marginTop: 20 }}>
                    {/* The LanguageSwitcher component itself would likely handle its own translation for its internal text */}
                    <LanguageSwitcher sx={{ minWidth: 120 }} /> 
                </div>          

                <div style={{ marginBottom: 20, marginTop: 20 }}>
                    <ThemeSwitcher sx={{ minWidth: 120 }} />
                </div>          
            </Stack>

            <CustomerDetailsForm />

        </Box>
    );
};

export default GeneralSettings;